import collectionApiClient, {
  CollectionAnalyticsQueryParams,
  CollectionStats,
} from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useCollectionStatsQuery = ({
  collectionId,
  period,
  enabled = true,
}: CollectionAnalyticsQueryParams) => {
  return useKlydoQuery<CollectionStats>({
    queryKey: ['collectionStats', collectionId, period],
    queryFn: () => collectionApiClient.getCollectionStats(collectionId, period),
    enabled: !!collectionId && enabled,
  });
};

export default useCollectionStatsQuery;
